import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-99bd2036"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "my-5 nes-container with-title text-xs"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex flex-row" }
const _hoisted_7 = ["alt", "src"]
const _hoisted_8 = {
  key: 1,
  class: "my-5 nes-container with-title text-xs"
}
const _hoisted_9 = { class: "title" }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_12 = {
  id: "ssuns",
  class: "sp"
}
const _hoisted_13 = { class: "flex flex-row" }
const _hoisted_14 = ["alt", "src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, null, -1))
const _hoisted_16 = {
  id: "ssuns",
  class: "og"
}
const _hoisted_17 = { class: "flex flex-row" }
const _hoisted_18 = ["alt", "src"]
const _hoisted_19 = { class: "pfpog flex flex-row" }
const _hoisted_20 = ["alt", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.n.metadataExternal.name.includes('Solsunsets SE') || _ctx.n.metadataExternal.symbol == 'SUNS')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.n.metadataExternal.name) + " | ", 1),
            _createElementVNode("a", {
              href: 'https://solscan.io/token/' + _ctx.n.mint,
              target: "_blank"
            }, "Solscan", 8, _hoisted_3),
            _hoisted_4
          ]),
          (_ctx.n.metadataExternal.name.includes('Solsunsets SE') || _ctx.n.metadataExternal.symbol == 'SUNS')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    alt: _ctx.n.mint,
                    src: _ctx.n.metadataExternal.properties.files[1].uri
                  }, null, 8, _hoisted_7)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.n.metadataExternal.name.includes('Solsunsets #') || _ctx.n.metadataExternal.symbol == 'SUNS')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("h2", _hoisted_9, [
            _createTextVNode(_toDisplayString(_ctx.n.metadataExternal.name) + " | ", 1),
            _createElementVNode("a", {
              href: 'https://solscan.io/token/' + _ctx.n.mint,
              target: "_blank"
            }, "Solscan", 8, _hoisted_10),
            _hoisted_11
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("img", {
                alt: _ctx.n.mint,
                src: _ctx.n.metadataExternal.properties.files[1].uri
              }, null, 8, _hoisted_14)
            ]),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("img", {
                alt: _ctx.n.mint,
                src: _ctx.n.metadataExternal.properties.files[3].uri
              }, null, 8, _hoisted_18)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("img", {
                alt: _ctx.n.mint,
                src: _ctx.n.metadataExternal.properties.files[2].uri
              }, null, 8, _hoisted_20)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}